export const CLASS_NAMES = {
  baseWrapper:
    'absolute border border-neutral-200 rounded-lg bg-neutral-000 shadow-popover z-30',
};
